import React from 'react';
import { Outlet } from 'react-router-dom';
import {
  BILLING_URL_PATH,
  CANCEL_URL_PATH,
  CONFIGURE_TABLES_URL_PATH,
  CREDITS_URL_PATH,
  MAP_URL_PATH,
  REPORT_URL_PATH,
  SETTINGS_URL_PATH,
  SETUP_URL_PATH,
  TEAM_URL_PATH,
} from './paths';

const TeamAccess = React.lazy(() => import('@/containers/TeamAccess'));
const MapContainer = React.lazy(
  () => import('@/components/er-diagram/MapContainer'),
);
const Credits = React.lazy(() => import('@/views/Credits'));
const SelectTables = React.lazy(
  () => import('@/components/configure/SelectTables_LEGACY'),
);
const Billing = React.lazy(() => import('@/views/Billing'));
const Settings = React.lazy(() => import('@/containers/Settings'));
const EditCredentials = React.lazy(
  () => import('@/components/credentials/EditCredentials'),
);
const CancelSubscription = React.lazy(
  () => import('@/features/subscription/components/CancelSubscription'),
);
const ReportView = React.lazy(() => import('@/views/Report'));
export default [
  {
    path: MAP_URL_PATH,
    element: <MapContainer />,
  },
  {
    path: SETTINGS_URL_PATH,
    element: <Settings />,
  },
  {
    path: CONFIGURE_TABLES_URL_PATH,
    element: (
      <div className="h-100 w-100">
        <SelectTables />
      </div>
    ),
  },
  {
    path: CREDITS_URL_PATH,
    element: <Credits />,
  },
  {
    path: TEAM_URL_PATH,
    element: <TeamAccess />,
  },
  {
    path: BILLING_URL_PATH,
    element: <Outlet />,
    children: [
      {
        index: true,
        element: <Billing />,
      },
      {
        path: CANCEL_URL_PATH,
        element: <CancelSubscription />,
      },
    ],
  },
  {
    path: SETUP_URL_PATH,
    element: <EditCredentials />,
  },
  {
    path: REPORT_URL_PATH,
    element: <ReportView />,
  },
];
